export class FrontFace {
    Type: EType = EType.Undefined;
    Index: number = 0;

    constructor(type: EType, index: number) {
        this.Type = type;
        this.Index = index;
    }
}

export enum EType {
    Undefined = 1,
    Front = 2,
    Left = 3,
    Right = 4,
}
